import React from 'react';
import { medsCreateState, createMedsStep } from 'store/storeValtio';

export default function MedicationDaily({ prevStep, nextStep }) {
  //console.log('MedicationDaily');

  function handleClick(times) {
    //console.log('handleClick', times);
    //const hr = hrs > 1 ? ' times' : ' time';
    //const often = `Every ${hrs}${hr}`;
    medsCreateState.often = 'daily';
    medsCreateState.occurance = times;
    medsCreateState.schedule = [];
    nextStep(createMedsStep.schedule);
}

  const times = [];
  for (let i = 1; i < 7; ++i) {
    const i_str = i.toString();
    const hr = i_str + i > 1 ? ' times' : ' time';
    const time = {
      'occurance': i,
      'text': i.toString() + ' ' + hr
    }
    times.push(time);
  }

  return (
    <>
      <div className='medBody text-center'>
        How <b>many times</b> a day do you take your medication?
      </div>
      <div className='medList'>
          {times.map((t,ix) => {
            const li = t.occurance === medsCreateState.occurance ? 'py-1 bg-green-300' : 'py-1 bg-slate-300';
            return (
              <div
                key={ix} 
                className={'medCard ' + li} 
                onClick={()=>handleClick(t.occurance)} 
                id={t.occurance}>
                  {t.text}
                </div>
              )
            })
          }
        </div>
    </>
  );
}
